import { SiteLayout } from '../../components/SiteLayout';
import { Icon } from '../../components/Icon';
import { usePageMeta } from '../../lib/meta';

const POINTS = [
  { icon: 'compass', text: 'Discover videos — works with YouTube' },
  { icon: 'download', text: 'Background downloads of direct media links' },
  { icon: 'folder', text: 'Import from Files and play offline' },
  { icon: 'sparkles', text: 'AI transcripts & summaries on paid plans' },
  { icon: 'lock', text: 'Subscriptions through the App Store' },
];

export function Ios() {
  usePageMeta('iPhone app', 'Ayonix Studio for iPhone is coming to the App Store. Until then, use the web app on iPhone.');
  return (
    <SiteLayout>
      <div class="container ios-page">
        <section class="ios-copy" aria-labelledby="ios-h">
          <h1 id="ios-h" class="display"><span class="grad">Ayonix Studio</span> <span>for iPhone</span></h1>
          <p class="lede">Discover, save and watch the media you’re allowed to keep — anywhere.</p>
          <ul class="ios-points">{POINTS.map((p) => <li key={p.text}><span class="strip-icon"><Icon name={p.icon} size={18} /></span>{p.text}</li>)}</ul>
          <div class="row cta-row">
            <span class="stack" style="gap:4px;align-items:flex-start">
              <button class="btn lg store-btn" type="button" disabled aria-describedby="ios-why" data-testid="app-store"><Icon name="apple" size={22} /><span class="stack" style="gap:0;align-items:flex-start"><small>Coming to the</small>App Store</span></button>
              <span id="ios-why" class="caption muted">Not yet available on the App Store. Requires iOS 17 or later.</span>
            </span>
            <a class="btn outline lg" href="/" data-testid="ios-web">Use the web app on iPhone <Icon name="arrowRight" size={18} /></a>
          </div>
        </section>
        <div class="phones" aria-label="iOS app screens from the iPhone simulator build">
          <figure class="phone back"><img src="/img/ios-launch.webp" width="603" height="1311" alt="Ayonix Studio for iPhone, Discover tab in light mode." loading="lazy" /></figure>
          <figure class="phone front"><img src="/img/ios-launch-dark.webp" width="603" height="1311" alt="Ayonix Studio for iPhone, Discover tab in dark mode." loading="lazy" /></figure>
        </div>
      </div>
    </SiteLayout>
  );
}
